export enum FilterSort {
  ALPHABETICAL,
  FREQUENCY
}
